import type { FiatPrice, WalletOffer } from "@b2bportal/wallet-offer-api";
import type { PartialParentContext } from "@checkout/types";
import type { WalletVoucherStatusEnum } from "@hopper-b2b/types";

export interface EligibleOffersResult {
  offers: WalletOffer[];
  roomOfferId: string | undefined;
}

export interface WalletInitResult extends EligibleOffersResult {
  creditBalance: FiatPrice | undefined;
}

interface TravelCreditContext {
  creditPaymentAmount: FiatPrice | undefined;
  creditBalance: number;
  /** True once the auto-init has run; prevents re-application on remount. */
  creditInitialized: boolean;
}

interface OfferContext {
  /**
   * The most recently applied offer. Persists after unchecking for tracking
   * purposes only — gate on `offerApplied` (see `getAppliedWalletOffer`).
   */
  selectedOffer?: WalletOffer;
  offers?: WalletOffer[];
  visited: boolean;
  error?: Error;
  fetchedOffers?: boolean;
  offerApplied?: boolean;
  // Reuse this enum here for tracking properties
  offerStatus?: WalletVoucherStatusEnum;
}

// These could be one of ParentState enum in libs/checkout
// but they are defined here to not introduce a change to libs/checkout
export const TravelCreditPaymentState = "travelCreditPayment";
export const OfferPaymentState = "offerPayment";
/**
 * CartUpdate instance for wallet-offer toggles; returns to `cardPayment.idle`
 * to skip the payment-methods refetch and panel remount.
 */
export const WalletOfferCartUpdateState = "walletOfferCartUpdate";

export interface WalletPaymentContext {
  [TravelCreditPaymentState]?: TravelCreditContext;
  [OfferPaymentState]?: OfferContext;
}

export interface WalletPaymentParentContext
  extends PartialParentContext,
    WalletPaymentContext {}

export enum WalletPaymentInformationState {
  loading = "loading",
  idle = "idle",
  error = "error",
}
